import type { UIManager } from '@/Core/Managers/UI'
import React from 'react'

interface PublicLayoutTemplateProps {
    layoutContext?: UIManager
    children: React.ReactNode
}

export const PublicLayoutTemplate: React.FC<PublicLayoutTemplateProps> = ({ children }) => {
    return <>{children}</>
}
